var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPointerBlueRoaming(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 53,
    viewBox: "0 0 44 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4076_14889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0059 2.5737e-05C24.6361 0.00429447 27.2399 0.527997 29.6671 1.54104C32.0942 2.55413 34.2977 4.03656 36.1505 5.90335C39.896 9.64898 42 14.7293 42.0001 20.0264C42.0001 25.3236 39.8961 30.4047 36.1505 34.1504L22.0264 47.9639L7.92 34.166C6.05104 32.3153 4.56571 30.1137 3.54988 27.6875C2.53407 25.2614 2.0073 22.6585 2.00007 20.0283C1.99288 17.3981 2.50535 14.7921 3.50789 12.3604C4.51037 9.92885 5.98322 7.71926 7.84187 5.85842C9.70069 3.99751 11.9094 2.52192 14.3399 1.51663C16.7704 0.511393 19.3758 -0.00419759 22.0059 2.5737e-05Z",
    fill: "#5B71DE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4076_14889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 9C15.93 9 11 13.93 11 20C11 26.07 15.93 31 22 31C22.49 31 22.96 30.96 23.43 30.9C23.41 30.82 23.38 30.74 23.38 30.65V26.41C22.99 27.14 22.54 27.84 22 28.49C20.22 26.29 19.23 23.67 19.04 21H24.6C24.6 21 24.62 21 24.63 21H27.99C27.99 21 28.05 21 28.08 21H30.95C30.92 21.3 30.85 21.59 30.78 21.88C30.89 21.96 31.01 22.03 31.11 22.13C31.67 22.64 32.04 23.28 32.24 24C32.72 22.76 33 21.42 33 20.01C33 13.93 28.07 9 22 9ZM19.68 28.69C16.15 27.75 13.47 24.72 13.06 21H17.04C17.21 23.7 18.09 26.35 19.68 28.69ZM17.04 19H13.06C13.47 15.29 16.15 12.26 19.68 11.31C18.1 13.64 17.22 16.3 17.04 19ZM19.04 19C19.24 16.33 20.22 13.71 22 11.51C23.78 13.71 24.77 16.33 24.96 19H19.03H19.04ZM26.96 19C26.79 16.3 25.91 13.65 24.32 11.31C27.85 12.25 30.53 15.28 30.94 19H26.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8299 26.54C31.0599 26.14 31.1699 25.69 31.1699 25.2C31.1699 24.31 30.8699 23.6 30.2699 23.06C29.6699 22.52 28.9099 22.25 27.9899 22.25H24.6299V30.65H27.0299V28.01H27.6299L28.9599 30.65H31.5299L29.8699 27.52C30.2799 27.27 30.5999 26.95 30.8199 26.55L30.8299 26.54ZM28.5499 25.82C28.3999 25.96 28.1999 26.02 27.9399 26.01H27.0299V24.45H27.9399C28.1999 24.45 28.3999 24.52 28.5499 24.66C28.6999 24.8 28.7699 24.99 28.7699 25.24C28.7699 25.49 28.6999 25.68 28.5499 25.82Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4076_14889",
    x: 0,
    y: 0,
    width: 44.0001,
    height: 52.9639,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4076_14889"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4076_14889",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4076_14889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(11 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPointerBlueRoaming);
export default __webpack_public_path__ + "static/media/map_pointer_blue_roaming.bba93619777276295a0720a23a304058.svg";
export { ForwardRef as ReactComponent };